import {get} from '@/api/common/index'
import { Message } from 'element-ui'
import router from '../router'
import CryptoJS from "crypto-js";

export function getUserInfo () {
  let userInfo = null
  let exists = false
  return new Promise((resolve,reject)=>{
    let userStrorage = window.localStorage.getItem("rent_userInfo")
    if (userStrorage) {
      try {
        var data = CryptoJS.AES.decrypt(CryptoJS.enc.Base64.stringify(CryptoJS.enc.Hex.parse(userStrorage)), CryptoJS.enc.Utf8.parse("1234567890ABCDEF"),{mode:CryptoJS.mode.ECB,padding:CryptoJS.pad.Pkcs7}).toString(CryptoJS.enc.Utf8);
        userInfo = JSON.parse(data);
        //exists = true;
        resolve(userInfo);
      } catch (e) {
          removeUserInfo()
          reject(e);
      }
    }
    
    if (!exists) {
      if (getLocalToken()) {
          get('/api/user/get_user_info').then(res=>{
          userInfo = res.data;
          var data = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(userInfo)), CryptoJS.enc.Utf8.parse("1234567890ABCDEF"),{mode:CryptoJS.mode.ECB,padding:CryptoJS.pad.Pkcs7}).ciphertext.toString().toUpperCase();
          window.localStorage.setItem("rent_userInfo",data)
          resolve(userInfo);
        }).catch(error=>{
          reject(error);          
        })
      }
    }
  }); 
}

export function checkRenter () {
  getUserInfo().then(data => {
    get('/api/rent/check_renter', {'cert_no': data.certNo}).then(res => {
      if (res.success === false) {
        if (res.data) {
          Message(res.data)
          router.push({path: 'UserIndex'})
        }
      }
    })
  })
}

export function removeUserInfo () {
    window.localStorage.removeItem('rent_userInfo')
}

export function getLocalToken () {
  return window.localStorage.getItem('token')
}

export function setLocalToken (token) {
    window.localStorage.setItem('token', token)
}

export function removeLocalToken () {
    window.localStorage.removeItem('token')
}
